import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getUsersList.success: {
            return action.payload;
        }

        case constants.getUsersList.error:
        case constants.getUsersList.try: {
            return initialState;
        }

        default:
            return state;
    }
}
